import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { Button } from './Button'


const useStyles = makeStyles(() => ({
    section: {
        background: `linear-gradient(120deg, ${tokens.colorPrimary}, ${tokens.colorPrimaryDark})`,
        padding: '46px 0',
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 30,
        flexWrap: 'wrap',
        '@media (max-width: 640px)': { flexDirection: 'column', alignItems: 'flex-start' },
    },
    title: { color: '#fff', fontSize: '3rem', marginBottom: 10,fontFamily: tokens.fontHeading},
    text: { color: '#D9DAF3', maxWidth: 720, fontSize: '1.2rem', margin: 0, fontFamily: tokens.fontBody },
    cta: { flex: '0 0 auto' },
}))

export function CtaBar() {
    const classes = useStyles()
    return (
        <section className={classes.section}>
            <Container>
                <div className={classes.inner}>
                    <div>
                        <h2 className={classes.title}>Elevate Your Testing Processes with SLS</h2>
                        <p className={classes.text}>
                            Get in touch today to explore how our tailored test automation
                            solutions can transform your testing process. Together, we&rsquo;ll
                            elevate your product quality and maximize efficiency.
                        </p>
                    </div>
                    <Button href="/contact" variant="light" className={classes.cta}>
                        Get a Quote
                    </Button>
                </div>
            </Container>
        </section>
    )
}
